import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import useLenis from "@/hooks/useLenis";

/**
 * Initializes Lenis smooth scrolling at the top of the React tree.
 * Lives above <App /> so the single Lenis instance persists across
 * route changes (unmounting Lenis per route would cause jank).
 */
const LenisProvider = ({ children }) => {
  useLenis();
  return children;
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <LenisProvider>
      <App />
    </LenisProvider>
  </React.StrictMode>,
);
